import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Sponsors = () => {
  return (
    <React.Fragment>
      <SEO title="Sponsors | DMBD 2023" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Sponsors"
        content="The Conference"
        contentTwo="Sponsors"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <div id="sponsors">
            <table width={1111}>

              <tbody>
                <tr>
                  <td width="260">
                    <h5>&nbsp;&nbsp;Sponsor</h5>
                  </td>
                  <td colSpan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img src="./images/logo/iasei.png" alt="iasei"
                      width="150" height="150"></img></div>
                  </td>
                  <td className="align-middle"><a href="http://iasei.org/">International
                    Association of Swarm
                    and Evolutionary Intelligence (IASEI)</a></td>
                </tr>
                <tr>
                  <td width="198">
                    <h5>&nbsp;&nbsp;Co-Sponsors</h5>
                  </td>
                  <td colSpan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img src="./images/logo/pku.svg.png" alt="pku"
                      width="150" height="150"></img></div>
                  </td>
                  <td className="align-middle"><a href="http://english.pku.edu.cn/">Peking
                    University</a></td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img src="./images/logo/cil.jpeg" alt="cil"
                      width="150" height="130"></img></div>
                  </td>
                  <td className="align-middle"><a
                    href="http://www.cil.pku.edu.cn/">Computational Intelligence
                    Laboratory</a></td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img src="./images/logo/aibd_logo.png" alt="AIBD"
                      width="150" height="150"></img></div>
                  </td>
                  <td className="align-middle"><a
                    href=""> Advanced Institute of Big Data, Beijing</a></td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img src="./images/logo/151663166293_.pic.jpg" alt="KLISR"
                      width="150" height="150"></img></div>
                  </td>
                  <td className="align-middle"><a
                    href="">Key Lab of Information System Requirement</a></td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img src="./images/logo/121663166076_.pic.jpg" alt="STISEL"
                      width="150" height="150"></img></div>
                  </td>
                  <td className="align-middle"><a
                    href="">Science and Technology on Information Systems Engineering Laboratory</a></td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img src="./images/logo/SUST.jpg" alt="SUST"
                      width="150" height="150"></img></div>
                  </td>
                  <td className="align-middle"><a
                    href="http://www.sustech.edu.cn/">Southern University of
                    Science and Technology </a></td>
                </tr>

                <tr>
                  <td>
                    <h5>&nbsp;&nbsp;Technical Co-Sponsors</h5>
                  </td>
                  <td colSpan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img
                      src="./images/logo/RRCS Logo.png"
                      alt="cis" width="280" height="120"></img></div>
                  </td>
                  <td className="align-middle"><a href="https://ojs.wiserpub.com/index.php/RRCS/">
                    Research Reports on Computer Science (RRCS)</a></td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img
                      src="./images/logo/IEEE-Computational-Intelligence-Society.jpg"
                      alt="cis" width="280" height="120"></img></div>
                  </td>
                  <td className="align-middle"><a href="http://www.cis.ieee.org/">IEEE
                    Computational
                    Intelligence Society</a></td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img
                      src="./images/logo/International-Neural-Network-Society.gif"
                      alt="inns" width="116" height="115"></img></div>
                  </td>
                  <td className="align-middle"><a
                    href="http://www.inns.org/">International Neural Network
                    Society</a></td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img
                      src="./images/logo/World-Federation-of-Soft-Computing.jpg"
                      alt="wsfc" width="130" height="118"></img></div>
                  </td>
                  <td className="align-middle"><a
                    href="http://www.softcomputing.org/">World Federation of
                    Soft
                    Computing</a></td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img src="./images/logo/ccic.png" alt="ccic"
                      width="130" height="118"></img></div>
                  </td>
                  <td className="align-middle"><a href="http://www.c2.org.cn/">City Brain
                    Technical Committee, Chinese Institute of Command and
                    Control (CICC)</a></td>
                </tr>

                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img src="./images/logo/kb_logo.png" alt="kangbo"
                      width="130" height="118"></img></div>
                  </td>
                  <td className="align-middle"><a
                    href="http://www.kiha.org.cn/index.html">Nanjing Kangbo
                    iHealth Academy</a></td>
                </tr>


                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img alt="springer"
                      src="./images/logo/Springer-Verlag.jpg" width="196" height="83"></img>
                    </div>
                  </td>
                  <td className="align-middle"><a
                    href="https://www.springer.com/">Springer</a></td>
                </tr>

                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img src="./images/logo/ccis.png" alt="lncs"
                      width="172" height="64"></img></div>
                  </td>
                  <td className="align-middle"><a
                    href="https://www.springer.com/series/7899">CCIS</a></td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img src="./images/logo/Entropy-logo3.png"
                      alt="entropy" width="172" height="64"></img></div>
                  </td>
                  <td className="align-middle"><a
                    href="https://www.mdpi.com/journal/entropy">Entropy</a></td>
                </tr>

                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img src="./images/logo/electronics-logo.png"
                      alt="electronics" width="172" height="64"></img></div>
                  </td>
                  <td className="align-middle"><a
                    href="https://www.mdpi.com/journal/electronics">MDPI
                    Electronics</a></td>
                </tr>

                <tr>
                  <td colSpan="2">
                    <div className="sp-logo"><img src="./images/logo/xflogoL.jpg" alt="xh"
                      width="145" height="125"></img></div>
                  </td>
                  <td className="align-middle"><a href="http://www.xinghui.com">Beijing
                    Xinghui High-Tech
                    Co.</a></td>
                </tr>

              </tbody>


              {/* <tbody>
                <tr>
                  <td width={260}>
                    <h5>&nbsp;&nbsp;Sponsor</h5>
                  </td>
                  <td colSpan={2}>&nbsp;</td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/iasei.png"
                        alt="iasei"
                        width={150}
                        height={150}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://iasei.org/">
                      International Association of Swarm and Evolutionary
                      Intelligence (IASEI)
                    </a>
                  </td>
                </tr>
                <tr>
                  <td width={198}>
                    <h5>&nbsp;&nbsp;Co-Sponsors</h5>
                  </td>
                  <td colSpan={2}>&nbsp;</td>
                </tr>

                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/PekingUniversityLogo.jpg"
                        alt="pku"
                        width={150}
                        height={150}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://english.pku.edu.cn/">Peking University</a>
                  </td>
                </tr>

                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/xj.png"
                        alt="sust"
                        width={150}
                        height={150}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://en.xjtu.edu.cn/">
                    Xi&apos;an Jiaotong University
                    </a>
                  </td>
                </tr>

                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/sxsf.png"
                        alt="ouc"
                        width={150}
                        height={150}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://english.snnu.edu.cn/">
                    Shaanxi Normal University{" "}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/xdu.png"
                        alt="ouc"
                        width={150}
                        height={150}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="https://www.xidian.edu.cn/">
                    Xidian University{" "}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/xiyou.jpg"
                        alt="ouc"
                        width={150}
                        height={150}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://www.xiyou.edu.cn/">
                    Xi&apos;an University of Posts and Telecommunications{" "}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/SUST.jpg"
                        alt="ouc"
                        width={150}
                        height={150}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://www.sustech.edu.cn/">
                    Southern University of Science and Technology{" "}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/cil.jpg"
                        alt="cil"
                        width={150}
                        height={130}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://www.cil.pku.edu.cn/">
                      Computational Intelligence Laboratory
                    </a>
                  </td>
                </tr>


               
                <tr>
                  <td>
                    <h5>&nbsp;&nbsp;Technical Co-Sponsors</h5>
                  </td>
                  <td colSpan={2}>&nbsp;</td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                    <img
                      src="./images/logo/IEEE-Computational-Intelligence-Society.jpg"
                      alt="cis"
                      width={280}
                      height={120}
                    />
                    </div>
                  </td>
                  <td>
                    <a href="http://www.cis.ieee.org/">
                    IEEE Computational Intelligence Society
                    </a>
                  </td>
                </tr>

                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/International-Neural-Network-Society.gif"
                        alt="inns"
                        width={116}
                        height={115}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://www.inns.org/">
                      International Neural Network Society
                    </a>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/World-Federation-of-Soft-Computing.jpg"
                        alt="wsfc"
                        width={130}
                        height={118}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://www.softcomputing.org/">
                      World Federation of Soft Computing
                    </a>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        alt="springer"
                        src="./images/logo/Springer-Verlag.jpg"
                        width={196}
                        height={83}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="https://www.springer.com/">Springer</a>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/LNCS.jpg"
                        alt="lncs"
                        width={172}
                        height={64}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="https://www.springer.com/lncs">LNCS</a>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/Entropy-logo3.png"
                        alt="xh"
                        width={172}
                        height={64}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="https://www.mdpi.com/journal/entropy">
                      Entropy
                    </a>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/xflogoL.jpg"
                        alt="xh"
                        width={145}
                        height={125}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://www.xinghui.com">
                      Beijing Xinghui High-Tech Co.
                    </a>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <div className="sp-logo">
                      <img
                        src="./images/logo/kangbo.png"
                        alt="kb"
                        width={300}
                        // height={125}
                      />
                    </div>
                  </td>
                  <td>
                    <a href="http://www.kiha.org.cn/index.html">
                    Nanjing  Kangbo  Intelligent  Health  Academy
                    </a>
                  </td>
                </tr>
              </tbody> */}
            </table>

            <div className="text-center">
          <a href="files/Sponsor.pdf" target="_blank"
            className="btn btn-primary">
            <h4 >Click here to download the Sponsorship rules</h4>
          </a>
        </div>
          </div>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Sponsors;
